<template>
  <keep-alive>
    <top-navbar :currentRoute="$route" :filter="false"></top-navbar>
  </keep-alive>

  <transition name="fade">
    <section v-if="!isReady">
      <div class="container-loading">
        <span class="loader loader-default loader-dark"></span>
      </div>
    </section>
  </transition>

  <transition name="fade">
    <div class="full-height-block" v-if="isReady">
      <section class="container-content">

        <div class="accordion-block">
          <div class="accordion-block-item">
            <div class="accordion-block-header pl-header">
              <div class="container-acc-header">
                Дата: 
                <span class="order-color-date">{{ data.startDate }}</span>
              </div>
              <div class="container-acc-header">
                Регион: 
                <span class="order-color-date">{{ data.region.name }}</span>
              </div>
              <div class="container-acc-header">
                Тип продукции: 
                <span class="order-color-date">{{ data.division }}</span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="data.items && data.items.length > 0" class="accordion-block" :openBlock="true" title="Товары">
          <table class="order-table">
            <tr>
              <th rowspan="2">Наименование/Артикул</th>
              <th rowspan="2">Цена с НДС</th>
              <th colspan="4" class="text-center">Количество </th>
              <th rowspan="2">Общая сумма</th>
            </tr>
            <tr>
              <th>ед</th>
              <th>м2</th>
              <th>м3</th>
              <th>кг</th>
            </tr>
            <tr v-for="(item, index) in data.items" :key="index" :value="item.id">
              <td>
                <span class="tab-text-name">{{ item.name }}</span><br>
                <span class="tab-text-art">{{ item.sku }}</span>
              </td>
              <td>{{ item.price }}</td>

              <td class="td-edit-field">
                <span>{{item.quantity}}</span>
              </td>

              <td class="td-edit-field">
                <span>{{item.area}}</span>
              </td>

              <td class="td-edit-field">
                <span>{{item.volume}}</span>
              </td>

              <td>{{ item.weight }}</td>
              <td class="text-right">{{ getItogItemSumm(item) }}</td>
            </tr>
          </table>
        </div>
        <div v-else class="empty-orders-notification mb-20 mt-20">
          Список товаров пуст.
        </div>

        <button v-show="data.fileRef" class="btn btn-default small-btn ml-10 download-btn mt-20" type="submit" @click="downloadFile(data.fileRef)">
          Скачать прайс-лист
          <mdicon name="download" width="17px"/>
        </button>

      </section>
    </div>
  </transition>

</template>

<script>
import TopNavbar from "../components/TopNavbar.vue";
import GlobalRequest from "@/plugins/globalRequest";
export default {
  name: 'PLDetailPage',
  components: {
    TopNavbar
  },
  data() {
    return {
      isReady: false,
      showEditQuantity: 0,
      showEditArea: 0,
      showEditVolume: 0,
      idGetPL: "",
      data: [],
      originOrderAllItems: [],
      itogQuantity: 0,
      itogArea: 0,
      itogVolume: 0,
      itogWeight: 0,
      itogSumm: 0,
      objectOrderDraft: {},
      dublicateItems: []
    }
  },

  async mounted() {
    await this.init()
  },

  methods: {

    async init() {
      this.isReady = false
      this.idGetPL = this.$route.query.id
      
      await this.getObjPL()

      this.isReady = true
    },

    async getObjPL() {
      let res = await GlobalRequest.request("/price-list/" + this.idGetPL, "GET")
      console.log(res)
      this.data = res.data
      this.data.startDate = this.formatDate(this.data.startDate)
      
      this.data.items.forEach(item => {
        item.quantity = 1;
      });

      this.calculateItog()

      let jsonItems = JSON.stringify(this.data.items) 
      this.originOrderAllItems = JSON.parse(jsonItems)
      this.dublicateItems = JSON.parse(jsonItems)
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    },

    getItogItemSumm(item) {
      let price = parseFloat(item.price).toFixed(2)
      let quantity = parseInt(item.quantity, 10)
      let itogSumm = price * quantity
      item.total = (itogSumm).toFixed(2)
      return (itogSumm).toFixed(2)
    },

    getEditArea(id) {
      if(this.showEditArea == 0 && this.showEditVolume == 0 && this.showEditQuantity == 0) 
        this.showEditArea = id
    },

    getEditVolume(id) {
      if(this.showEditArea == 0 && this.showEditVolume == 0 && this.showEditQuantity == 0) 
        this.showEditVolume = id
    },

    getEditQuantity(id) {
      if(this.showEditArea == 0 && this.showEditVolume == 0 && this.showEditQuantity == 0) 
        this.showEditQuantity = id
    },

    calculateQuantity(item) {
      // округляем на всякий
      item.quantity = Math.round(item.quantity)
      if(item.quantity < 0) item.quantity = 1

      // Получить товар в изначальном виде,как в бд для расчета
      let originItem = this.originOrderAllItems.find(elem => elem.id === item.id);
      let itemArea = parseFloat(originItem.area);     
      let itemVolume = parseFloat(originItem.volume);   
      let itemWeight = parseFloat(originItem.weight);    

      // рассчет area
      item.area = (item.quantity * itemArea).toFixed(2);

      // рассчет volume
      item.volume = (item.quantity * itemVolume).toFixed(2);

      // рассчет weight
      item.weight = (item.quantity * itemWeight).toFixed(2);

      this.showEditQuantity = 0;
      this.calculateItog()
    },

    calculateArea(item) { // m2
      
      // Получить товар в изначальном виде,как в бд для расчета
      let originItem = this.originOrderAllItems.find(elem => elem.id === item.id);
      let itemArea = parseFloat(originItem.area);     
      // После завершения редактирования поля пользователем должно произойти округление 
      // указанного в поле значения до ближайшего числа, кратного (Item.Area)
      if(parseFloat(item.area) < itemArea)
        item.area = itemArea
      else
        item.area = (Math.round(item.area / itemArea) * itemArea).toFixed(2);

      let orderItemArea = parseFloat(item.area);
      let itemVolume = parseFloat(originItem.volume); 
      let itemWeight = parseFloat(originItem.weight); 

      // рассчет quantity  
      item.quantity = Math.round(orderItemArea / itemArea);

      // рассчет volume  
      item.volume = (orderItemArea / itemArea * itemVolume).toFixed(2);

      // рассчет weight
      item.weight = (orderItemArea / itemArea * itemWeight).toFixed(2);

      this.showEditArea = 0
      this.calculateItog()
    },

    calculateVolume(item) { // m3
      // Получить товар в изначальном виде,как в бд для расчета
      let originItem = this.originOrderAllItems.find(elem => elem.id === item.id);
      let itemVolume = parseFloat(originItem.volume);

      // После завершения редактирования поля пользователем должно произойти округление 
      // указанного в поле значения до ближайшего числа, кратного Item.Volume
      if(parseFloat(item.volume) < itemVolume)
        item.volume = itemVolume
      else
        item.volume = (Math.round(item.volume / itemVolume) * itemVolume).toFixed(2);

      let orderItemVolume = parseFloat(item.volume);
      let itemArea = parseFloat(originItem.area);
      let itemWeight = parseFloat(originItem.weight); 

      // рассчет quantity
      item.quantity = Math.round(orderItemVolume / itemVolume);

      // рассчет area
      item.area = (orderItemVolume / itemVolume * itemArea).toFixed(2);

      // рассчет weight
      item.weight = (orderItemVolume / itemVolume * itemWeight).toFixed(2);

      this.showEditVolume = 0
      this.calculateItog()
    },

    calculateItog() {
      this.itogQuantity = 0;
      this.itogArea = 0;
      this.itogVolume = 0;
      this.itogWeight = 0;
      this.itogSumm = 0;
      this.data.items.forEach(item => {
          this.itogQuantity += item.quantity
          this.itogArea += parseFloat(item.area)
          this.itogVolume += parseFloat(item.volume)
          this.itogWeight += parseFloat(item.weight)
          this.itogSumm += parseFloat(item.price)*item.quantity
        });
    },

    // Скачать ПЛ
    downloadFile(fileUrl) {
      if(fileUrl) {
        const a = document.createElement('a');
        a.href = fileUrl; // Используем существующий URL
        a.download = fileUrl.split('/').pop(); // Название файла
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    },

    isEmpty(data) {
      if(data != "" && data != " " && data != 0 && data != null) {
        if(data.length > 0) return false
      }
      else {
        return true
      }
    },

  }
}
</script>